import React from "react";
import Header1 from "../component/Header1";

const KetoBlogs = () => {
  const blogPosts = [
    {
      title: "Little More Persistence, Little More Perseverance",
      date: "August 24, 2023",
      excerpt:
        "Losing weight is not an easy feat, especially if you lack the motivation (which is usually the case)- we completely understand. Do not be worried, this is not an unrealistic hyper-positive clickbait. We have five easy steps for you to remember...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/08/1-Little-more-Persistence-Little-more-Perseverance.jpg",
    },
    {
      title: "Intermittent Fasting Schedules",
      date: "January 5, 2024",
      excerpt:
        "No one strategy is universally effective for anything ever, so it’s only natural that Intermittent fasting can be done in a variety of ways. People usually experiment with different forms before they find what works best for their lifestyles...",
      image: "https://blog.ketobalanced.com/wp-content/uploads/2024/01/4-6.jpg",
    },
    {
      title: "How is the Mediterranean diet different from Keto?",
      date: "January 5, 2024",
      excerpt:
        "Wondering why the Mediterranean and Keto diets are the talk of the town lately? Let’s take a look at both of these diets. The ketogenic diet is an incredibly low-carb, high-fat diet that calls for a sharp drop in the consumption of...",
      image: "https://blog.ketobalanced.com/wp-content/uploads/2024/01/1-1.jpg",
    },

    {
      title: "Heart Happy, Kidney Healthy",
      date: "January 5, 2024",
      excerpt:
        "An explicable bond, interlinked together since forever: the heart and the kidney. If your heart is affected, your kidneys will suffer, and vice versa. Let me explain today how. The heart is the primary organ in the cardiovascular system that...",
      image: "https://blog.ketobalanced.com/wp-content/uploads/2024/01/1-5.jpg",
    },
    {
      title: "Autophagy and its Importance",
      date: "December 13, 2023",
      excerpt:
        "A cell must engage in autophagy in order to continue to exist and thrive. This entails converting the malfunctioning parts of the cells back into healthy ones or eliminating them. This frees up space and increases efficiency. This process also...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/12/Autophagy-and-its-Importance-1.jpg",
    },
    {
      title: "Daily Life and Keto: a Weight Loss Affair",
      date: "October 13, 2023",
      excerpt:
        "Occasionally, when I am enjoying a good meal, a smile will appear on my face. It might be a decadent piece of cheesecake, a juicy double patty burger, or even just a delicious bowl of caesar salad. One of life’s greatest pleasures that we...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/10/Daily-Life-and-Keto-a-Weight-Loss-Affair.jpg",
    },
    {
      title: "History Behind One of Trendiest Diets Ever",
      date: "October 13, 2023",
      excerpt:
        "How does fasting, i.e. in this case, ketosis cure epilepsy? We have all heard how keto went from becoming the seizure cure to a weight shredder aid, but have you ever wondered how they discovered this? The history dates back to ancient Greece in...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/10/History-Behind-One-of-Trendiest-Diets-Ever.jpg",
    },
    {
      title: "Self-Discipline for Keto Beginners",
      date: "October 13, 2023",
      excerpt:
        "Staying strong on a diet when you first start, is always a stressful thing. It is important to keep yourself hydrated and self-disciplined. The food you consume affects your lifestyle heavily since a person’s mood is directly proportional...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/10/Self-Discipline-for-Keto-Beginners.jpg",
    },
    {
      title: "Is Keto Not For Vegetarians?",
      date: "October 13, 2023",
      excerpt:
        "Keto is not Vegetarian friendly, is not a fact but an assumption. As we all know, following a plant-based diet or becoming entirely vegetarian can have positive effects on your health. In comparison to carnivores, vegetarians tend to suffer from...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/10/Is-Keto-Not-For-Vegetarians.jpg",
    },
    {
      title: "Have you ever Heard of Bulletproof Coffee?",
      date: "October 13, 2023",
      excerpt:
        "Simply put, Bulletproof coffee, or better known as the keto coffee, is a caffeinated beverage containing a lot of calories. Now you might wonder why coffee can suddenly have fats? Because it is made with butter! It is meant to energize your day...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/10/Have-you-ever-heard-of-Bulletproof-Coffee.jpg",
    },
    {
      title: "Battle of the Best … Diets of course!",
      date: "August 24, 2023",
      excerpt:
        "Since most people get 50% of their calories from carbs, your carb consumption has to be slowly lowered once you start whichever diet you feel comfortable with. When you start keto, your body stops relying on sugar. Instead, it chooses to burn...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/08/5-BATTLE-OF-THE-BEST-DIETS-OF-COURSE.jpg",
    },
    {
      title: "BHB Supplements: Safe or Not?",
      date: "August 24, 2023",
      excerpt:
        "What is β-HB? Keto can be excruciating in the beginning which is why there has been a rise in the new trend of using β-Hydroxybutyric (BHB) supplement pills to speed up the process of weight loss. As we all know, Keto is a low-carb high-fat diet...",
      image:
        "https://blog.ketobalanced.com/wp-content/uploads/2023/08/2-BHB-SUPPLEMENTS-SAFE-OR-NOT.jpg",
    },
  ];

  return (
    <div className="bg-custombgColor">
      <Header1 />
      <div className="container mx-auto px-4 py-8 ">
        <div className="py-8">
          <p className="text-center text-headingColor">Hey there!</p>
          <h1 className="text-4xl font-semibold text-center text-gray-800 mb-8 tracking-wide text-headingColor">
            Your one stop support for every step of the way
          </h1>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <div
              key={index}
              className={`bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
                index == 0 && "col-span-2"
              }`}
            >
              {/* Post Image */}
              <div className="relative">
                <img
                  src={post.image}
                  alt={post.title}
                  className={`w-full  object-cover transition-all duration-300 transform hover:scale-110 ${
                    index == 0 ? "h-96" : "h-56"
                  }`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
                  <h2 className="text-2xl font-bold text-white tracking-wide">
                    {post.title}
                  </h2>
                </div>
              </div>

              {/* Post Content */}
              <div className="p-6 tracking-wide">
                <p className="text-sm text-ftrgreenColor mb-4">{post.date}</p>
                <p className="text-gray-700 mb-4 tracking-wide">
                  {post.excerpt}
                </p>
                {/* <a
                href="#"
                className="text-blue-600 hover:text-blue-800 font-semibold transition-all duration-200"
              >
                Read More
              </a> */}
              </div>
            </div>
          ))}
        </div>
        {/* Call to Action */}
        <div className="mt-16 text-center bg-btngreenColor py-12">
          <h2 className="text-3xl font-semibold text-btntextColor tracking-wide">
            Ready to Fuel Your Keto Journey?
          </h2>
          <p className="mt-4 text-lg text-headingColor tracking-wide">
            Explore Ketobalanced products and take your keto diet to the next
            level!
          </p>
          <a
            href="https://usa.ketobalanced.com"
            className="mt-4 inline-block px-8 py-3 bg-ftrgreenColor text-white font-semibold rounded-lg hover:bg-green-700 tracking-wide !cursor-pointer"
          >
            Get Started!
          </a>
        </div>
      </div>
    </div>
  );
};

export default KetoBlogs;
